import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ClientService,
  IClient,
  IMobileVerificationDto,
  ToastService,
  UserService,
} from 'src/app/core';

@Component({
  selector: 'ic-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss'],
})
export class OtpVerificationComponent implements OnInit {
  @Input() dialogData: any;
  public mobileVerification: IMobileVerificationDto;
  public clientConfig: IClient;
  public title: string = 'Verify Mobile Number';

  constructor(
    private readonly clientService: ClientService,
    private readonly userService: UserService,
    private readonly toastService: ToastService,
    public readonly activeDialog: NgbActiveModal
  ) {
    this.clientConfig = this.clientService.currentClientValue;
  }

  ngOnInit(): void {
    this.title = this.dialogData?.title ?? this.title;
    this.mobileVerification = this.dialogData;
  }

  getOtp(isCall: boolean) {
    const mobile = this.userService.getMobile();
    if (mobile) {
      const number = this.mobileVerification.mobile;
      const isVerified = mobile.some((s) => s === Number(number));
      if (isVerified) {
        //this.mobileVerification = null;
        this.toastService.showSuccess('Number is already verified');
        this.activeDialog.close(this.mobileVerification.mobile);
        return;
      }
    }

    this.mobileVerification.otp = null;
    this.mobileVerification.token = null;
    this.mobileVerification.isCall = isCall;
    this.mobileVerification.outletId = this.clientConfig.outlet.id;
    this.validateOtp();
  }

  validateOtp() {
    this.userService.validateOtp(this.mobileVerification).subscribe(
      (data) => {
        if (data.isSuccess) {
          this.mobileVerification.token = data.result.token;
          if (data.result.isValidOtp) {
            const mobile = this.userService.getMobile();
            if (!mobile) {
              this.userService.setCurrentMobile(
                [Number(this.mobileVerification.mobile)],
                true
              );
            } else {
              mobile.push(Number(this.mobileVerification.mobile));
              this.userService.setCurrentMobile(mobile, true);
            }
            //this.mobileVerification = null;
            this.toastService.showSuccess('OTP verified successfully');
            this.activeDialog.close(this.mobileVerification.mobile);
            return;
          }
          this.toastService.showSuccess(
            this.mobileVerification.isCall
              ? 'Call Initiated successfully'
              : 'OTP sent successfully'
          );
        } else {
          this.toastService.showError(data.errors[0]);
        }
      },
      (err) => {
        this.toastService.showError(err);
      }
    );
  }

  nullOrEmpty(text: string, length: number): boolean {
    return text === null || text === '' || text?.length !== length;
  }

  closeDialog() {
    this.activeDialog.close();
  }
}
